import { ReactComponent as activity } from './resource_activity.svg';
import { ReactComponent as app } from './resource_app.svg';
import { ReactComponent as article } from './resource_article.svg';
import { ReactComponent as book } from './resource_book.svg';
import { ReactComponent as course } from './resource_course.svg';
import { ReactComponent as doc } from './resource_doc.svg';
import { ReactComponent as graphic } from './resource_graphic.svg';
import { ReactComponent as otherEN } from './resource_other_EN.svg';
import { ReactComponent as otherES } from './resource_other_ES.svg';
import { ReactComponent as otherPT } from './resource_other_PT.svg';
import { ReactComponent as pdf } from './resource_pdf.svg';
import { ReactComponent as podcast } from './resource_podcast.svg';
import { ReactComponent as slideshow } from './resource_slideshow.svg';
import { ReactComponent as video } from './resource_video.svg';
import { ReactComponent as website } from './resource_website.svg';
import { ReactComponent as xls } from './resource_xls.svg';

export default {
  activity,
  app,
  article,
  book,
  course,
  doc,
  graphic,
  otherEN,
  otherES,
  otherPT,
  pdf,
  podcast,
  slideshow,
  video,
  website,
  xls,
};
